export default __webpack_public_path__ + "static/media/carousel-img-9.a1af4a6a.webp";